import { CircularProgress } from '@mui/material';
import { Grid } from '@mui/material';
import GridContainer from 'components/GridContainer';
import SnapshotBox from 'components/SnapshotBox/SnapshotBox';
import { numberToCurrencyString } from 'further-ui/utils';

type Totals = {
  investors: number;
  investments: number;
  totalInitialInvestment: number;
  totalUnrealisedValue: number;
  totalRealisedValue: number;
};

type AdviserSnapshotProps = {
  totals?: Totals;
  isLoading: boolean;
};

export const AdviserSnapshot = ({
  totals,
  isLoading,
}: AdviserSnapshotProps) => {
  const {
    investors = 0,
    investments = 0,
    totalInitialInvestment = 0,
    totalUnrealisedValue = 0,
    totalRealisedValue = 0,
  } = totals || {};

  const averageSubscriptionAmount =
    investments > 0 ? totalInitialInvestment / investments : 0;

  if (isLoading) {
    return (
      <GridContainer>
        <Grid
          size={{ xs: 12 }}
          style={{ textAlign: 'center', padding: '2rem' }}
        >
          <CircularProgress />
        </Grid>
      </GridContainer>
    );
  }
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Grid container spacing={2} justifyContent="space-between">
          <Grid size={{ xs: 'grow' }}>
            <SnapshotBox value={investors} subtitle="Investors" />
          </Grid>
          <Grid size={{ xs: 'grow' }}>
            <SnapshotBox value={investments} subtitle="Subscriptions" />
          </Grid>
        </Grid>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Grid container spacing={2} justifyContent="space-between">
          <Grid size={{ xs: 'grow' }}>
            <SnapshotBox
              value={numberToCurrencyString(totalInitialInvestment, {
                currency: 'GBP',
              })}
              subtitle="Total subscribed"
            />
          </Grid>
          <Grid size={{ xs: 'grow' }}>
            <SnapshotBox
              value={numberToCurrencyString(totalUnrealisedValue, {
                currency: 'GBP',
              })}
              subtitle="Unrealised value"
            />
          </Grid>
          <Grid size={{ xs: 'grow' }}>
            <SnapshotBox
              value={numberToCurrencyString(totalRealisedValue, {
                currency: 'GBP',
              })}
              subtitle="Realised value"
            />
          </Grid>
          <Grid size={{ xs: 'grow' }}>
            <SnapshotBox
              value={numberToCurrencyString(averageSubscriptionAmount, {
                currency: 'GBP',
              })}
              subtitle="Average subscription"
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AdviserSnapshot;
